import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import ExhibitionFilter from "../components/ExhibitionFilter";
import bi_filter_yellow from "../assets/icons/bi_filter_yellow.png";
import house_icon from "../assets/icons/house_icon.png";
import clock_icon from "../assets/icons/clock_icon.png";
import locationPin_icon from "../assets/icons/locationPin_icon.png";
import users_icons from "../assets/icons/users_icons.png";
import { Link } from "react-router-dom";

const ExhibitionPage = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const [exhibitionFilter, setExhibitionFilter] = useState(false);

  const toggleExhibitionFilter = () => {
    setExhibitionFilter(!exhibitionFilter);
  };
  return (
    <>
      <div>
        <div className="flex items-center justify-center w-full">
          <div
            className="items-center justify-center hidden hamburger"
            onClick={toggleNavbar}
          >
            <img
              src={hamburger_icon}
              alt="hamburger"
              className="object-contain"
            />
          </div>
          <div className="flex items-center justify-center w-full">
            <SearchBar categoryName="Exhibition Master" />
          </div>
          <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
            {isNavbarVisible && <Navbar />}
          </div>
        </div>

        <div className="flex my-8 mx-4 justify-between exhibition">
          <div className={`${exhibitionFilter ? "w-[80%]" : "w-[95%]"}`}>
            {/* Exhibition Name 1 */}
            <div className="border rounded-lg">
              <div className="p-4">
                <p className="text-[#333333] font-bold text-16px">
                  Exhibition Name 1
                </p>
                <div className="flex justify-between items-center">
                  <div className="text-[14px]">
                    <div className="flex">
                      <img
                        src={house_icon}
                        alt="house"
                        className="w-3 object-contain mr-1"
                      />
                      <p>23rd Oct 2023 - 25th Oct 2023</p>
                    </div>
                    <div className="flex mt-1">
                      <img
                        src={clock_icon}
                        alt="clock"
                        className="w-3 object-contain mr-1"
                      />
                      <p>10:00am - 13:00pm</p>
                    </div>
                  </div>
                  <div>
                    <img src={locationPin_icon} alt="location" />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center bg-[#ECECEC] px-4 rounded-b-lg">
                <div className="flex text-[#989898] text-[14px] items-center py-2">
                  <div>Leads</div>
                  <img src={users_icons} alt="users" className="ml-2 w-20" />
                </div>
                <div className="text-[#3485BB] underline text-[16px] cursor-pointer">
                  <Link to="/exhibition/exhibitionUserList">Invite leads</Link>
                </div>
              </div>
            </div>

            {/* Exhibition Name 2 */}
            <div className="border rounded-lg mt-6">
              <div className="p-4">
                <p className="text-[#333333] font-bold text-16px">
                  Exhibition Name 2
                </p>
                <div className="flex justify-between items-center">
                  <div className="text-[14px]">
                    <div className="flex">
                      <img
                        src={house_icon}
                        alt="house"
                        className="w-3 object-contain mr-1"
                      />
                      <p>03rd Oct 2023 - 05th Oct 2023</p>
                    </div>
                    <div className="flex mt-1">
                      <img
                        src={clock_icon}
                        className="w-3 object-contain mr-1"
                        alt="clock"
                      />
                      <p>10:00am - 13:00pm</p>
                    </div>
                  </div>
                  <div>
                    <img src={locationPin_icon} alt="location" />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center bg-[#ECECEC] px-4 rounded-b-lg">
                <div className="flex text-[#989898] text-[14px] items-center py-2">
                  <div>Leads</div>
                  <img src={users_icons} alt="users" className="ml-2 w-20" />
                </div>
                <div className="text-[#3485BB] underline text-[16px] cursor-pointer">
                  <Link to="/exhibition/exhibitionUserList">Invite leads</Link>
                </div>
              </div>
            </div>

            {/* Add new Exhibition */}
            <div className="bg-[#2F80ED] mt-6 p-3 rounded-lg text-white text-[14px] text-center cursor-pointer">
              Add New Exhibition
            </div>
          </div>
          <div className={`${exhibitionFilter ? "w-[14rem]" : ""}`}>
            <div className="flex justify-end w-full">
              <div className="w-full flex justify-end">
                <img
                  src={bi_filter_yellow}
                  alt="filters"
                  className="cursor-pointer w-10 shadow-lg"
                  onClick={toggleExhibitionFilter}
                />
              </div>
            </div>
            {exhibitionFilter ? (
              <div className="w-full exhibition-filter">
                <ExhibitionFilter />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ExhibitionPage;
